<template>
  <div id="users-news-users-new-root">
    <router-view />
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
